import {getApiUrl} from "./client";
import {HOTSPOT_HABITAT_OVERRIDE_SUMMARY_ENDPOINT} from "./constants";
import type {HotspotHabitatOverride} from "../helpers/types";

export type HotspotHabitatOverrideSummaryResponse = {
    status: string;
    overridesByLocationId: Record<string, HotspotHabitatOverride>;
};

export const getHotspotHabitatOverrideSummary = async (locationIds: string[]) => {
    const response = await fetch(getApiUrl(HOTSPOT_HABITAT_OVERRIDE_SUMMARY_ENDPOINT), {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            locationIds
        })
    });

    if (!response.ok) {
        let message = `Habitat override summary failed with ${response.status}`;

        try {
            const payload = await response.json();
            if (payload?.message) {
                message = payload.message;
            }
        } catch (error) {
            // Ignore parse errors and surface the HTTP status instead.
        }

        throw new Error(message);
    }

    return await response.json() as HotspotHabitatOverrideSummaryResponse;
};
